import { ICategorys, IGameCell } from "@/common/interface";
import Link from "@/components/common/Link";
import SoftBtn from "@/components/common/SoftBtn";
import React from "react";
import "./index.scss";
import Img from "@/components/common/Img";
import { OpenType } from "@q/softCore";

interface IProps {
  data: IGameCell;
  position?: string;
}

const Card = ({ data, position }: IProps) => {
  const { soft_id, open_first, open_type, exec, href, btn_text } = data;
  const configData = {
    open_first,
    open_type,
    exec,
    href,
    btn_text,
  };

  const linkConfig = soft_id
    ? {
        openType: OpenType.openDetailInHome,
      }
    : {
        openType: open_type,
        exec,
        href,
      };
  const categoryText =
    data.category && data.category.length > 0
      ? `${ICategorys[data.category]}`
      : `${ICategorys[1]}`;
  return (
    <div className="card">
      <Link
        className="card__link"
        softId={soft_id}
        openType={linkConfig.openType}
        exec={linkConfig.exec}
        href={linkConfig.href}
        dataText={categoryText}
        name={data.name}
        position={position}
        comAds={data.clktk}
        category={data.category}
      >
        <Img
          className="card__img"
          src={data.choice_pic_href_max || data.single_pic_href}
        />
        <div className="card__cover">
          <div className="card__content">
            <div className="card__name text-overflow">{data.name}</div>
            <SoftBtn
              className="card__btn"
              softId={soft_id}
              configData={configData}
              name={data.name}
              position={position}
              comAds={data.clktk}
            />
          </div>
        </div>
      </Link>
    </div>
  );
};

export default Card;
